// Axion Elite — Click Spark CTA feedback
// Vanilla-JS port of a click-particle effect, scaled down to match the
// "precision, not playfulness" motion philosophy: fewer/shorter lines,
// faster duration, eased with the theme's --ease-sharp curve rather than
// a bouncy/spring easing.

(function () {
  var SPARK_COUNT = 4;
  var SPARK_SIZE = 6;
  var SPARK_RADIUS = 10;
  var DURATION = 300;
  var TARGET_SELECTOR = '.js-click-spark';
  var CANVAS_CLASS = 'axion-click-spark-canvas';
  // Mirrors --ease-sharp: cubic-bezier(0.16, 1, 0.3, 1)
  var EASE_P1X = 0.16, EASE_P1Y = 1, EASE_P2X = 0.3, EASE_P2Y = 1;

  function bezierComponent(t, p1, p2) {
    var mt = 1 - t;
    return 3 * mt * mt * t * p1 + 3 * mt * t * t * p2 + t * t * t;
  }

  // Solves cubic-bezier(x) for t at a given x (progress), then returns the
  // corresponding y — same curve shape as the CSS --ease-sharp token.
  function easeSharp(progress) {
    var t = progress;
    for (var i = 0; i < 8; i++) {
      var x = bezierComponent(t, EASE_P1X, EASE_P2X) - progress;
      var dx = 3 * (1 - t) * (1 - t) * EASE_P1X
        + 6 * (1 - t) * t * (EASE_P2X - EASE_P1X)
        + 3 * t * t * (1 - EASE_P2X);
      if (Math.abs(dx) < 1e-6) break;
      t -= x / dx;
    }
    return bezierComponent(t, EASE_P1Y, EASE_P2Y);
  }

  function getSparkColor() {
    var value = getComputedStyle(document.documentElement)
      .getPropertyValue('--color-accent-gold');
    return value ? value.trim() : '#C9A24B';
  }

  function init() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    // Skip entirely on pages with no opted-in CTA — no canvas, no listeners.
    if (!document.querySelector(TARGET_SELECTOR)) return;

    var canvas = document.createElement('canvas');
    canvas.className = CANVAS_CLASS;
    document.body.appendChild(canvas);

    var ctx = canvas.getContext('2d');
    var sparkColor = getSparkColor();
    var sparks = [];
    var resizeTimeout;
    var rafId = null;

    function resizeCanvas() {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    }

    function handleResize() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(resizeCanvas, 100);
    }

    resizeCanvas();
    window.addEventListener('resize', handleResize);

    function draw(timestamp) {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      sparks = sparks.filter(function (spark) {
        var elapsed = timestamp - spark.startTime;
        if (elapsed >= DURATION) return false;

        var progress = elapsed / DURATION;
        var eased = easeSharp(progress);
        var distance = eased * SPARK_RADIUS;
        var lineLength = SPARK_SIZE * (1 - eased);

        var x1 = spark.x + distance * Math.cos(spark.angle);
        var y1 = spark.y + distance * Math.sin(spark.angle);
        var x2 = spark.x + (distance + lineLength) * Math.cos(spark.angle);
        var y2 = spark.y + (distance + lineLength) * Math.sin(spark.angle);

        ctx.strokeStyle = sparkColor;
        ctx.lineWidth = 2;
        ctx.beginPath();
        ctx.moveTo(x1, y1);
        ctx.lineTo(x2, y2);
        ctx.stroke();

        return true;
      });

      // Idle out once every spark has finished — no perpetual per-frame
      // cost on pages between clicks.
      if (sparks.length > 0) {
        rafId = requestAnimationFrame(draw);
      } else {
        rafId = null;
      }
    }

    function ensureDrawLoop() {
      if (rafId === null) {
        rafId = requestAnimationFrame(draw);
      }
    }

    document.addEventListener('click', function (event) {
      var target = event.target.closest(TARGET_SELECTOR);
      if (!target) return;

      var now = performance.now();
      for (var i = 0; i < SPARK_COUNT; i++) {
        sparks.push({
          x: event.clientX,
          y: event.clientY,
          angle: (2 * Math.PI * i) / SPARK_COUNT,
          startTime: now
        });
      }
      ensureDrawLoop();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
